import { render, staticRenderFns } from "./ReplyComplaintAppraise.vue?vue&type=template&id=35ab13bb"
import script from "./ReplyComplaintAppraise.vue?vue&type=script&lang=js"
export * from "./ReplyComplaintAppraise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports